// extracted by mini-css-extract-plugin
module.exports = {"SwitchButton":"SwitchButton_SwitchButton__3mNwm","Active":"SwitchButton_Active__34Dts"};